{
  "version": 1,
  "asset_id": "028f7f05-c6be-4914-a3a1-e61fb08930ff",
  "project_id": "1c7313b7-7160-4256-be8b-cc48c05288da",
  "url": "/__l5e/assets-v1/028f7f05-c6be-4914-a3a1-e61fb08930ff/aleph-commodities-1400.webp",
  "r2_key": "a/v1/1c7313b7-7160-4256-be8b-cc48c05288da/028f7f05-c6be-4914-a3a1-e61fb08930ff/aleph-commodities-1400.webp",
  "original_filename": "aleph-commodities-1400.webp",
  "size": 353990,
  "content_type": "image/webp",
  "created_at": "2026-10-20T23:04:53Z"
}
